import { ArrowLeft, ArrowRight, User, Video, Sparkles, Monitor, Mic, Layers, Palette, Users } from 'lucide-react';
import './LandingPage.css';

export default function PresenTourPage({ onBack, onDemo }) {
  return (
    <div className="lp" data-testid="presentour-page">
      <div className="sp-hero sp-hero-pink" data-testid="sp-hero">
        <button className="sp-back sp-back-right" onClick={onBack} data-testid="sp-back">
          Back to NicheSocial <ArrowRight size={16} />
        </button>
        <div className="sp-hero-inner">
          <div className="sp-hero-content">
            <span className="sp-badge">Included in Social Pro</span>
            <h1 className="sp-title">PresenTour</h1>
            <p className="sp-subtitle">
              Avatar-led video presentations that put your agents front and centre.
              Scripted, professional, and consistent for every listing.
            </p>
            <p className="sp-body">
              A high-quality AI presenter is created for each agent, captured once and reused
              across all future property videos, market updates, and social content.
            </p>
            <button className="sp-cta" onClick={onDemo} data-testid="sp-cta">
              Book a Demo <ArrowRight size={16} />
            </button>
          </div>
          <div className="sp-hero-visual">
            <div className="sp-icon-ring">
              <User size={48} />
            </div>
          </div>
        </div>
      </div>

      <section className="sp-section sp-section-grey" data-testid="sp-use-cases">
        <div className="sp-container">
          <h2 className="sp-h2">What agents use PresenTour for</h2>
          <div className="sp-use-grid">
            <div className="sp-use" data-testid="sp-use-tours">
              <h3>Property Tours</h3>
              <p>Professional, scripted walk-throughs of every listing. Your agent's avatar guides viewers room by room with confidence and consistency.</p>
            </div>
            <div className="sp-use" data-testid="sp-use-market">
              <h3>Market Updates</h3>
              <p>Branch-branded market insight videos presented by your agent's avatar. Position your team as local experts without filming a thing.</p>
            </div>
            <div className="sp-use" data-testid="sp-use-social">
              <h3>Engaging Social Content</h3>
              <p>Stand-out reels and stories that feature your agents. Build trust and personal brand across every social platform.</p>
            </div>
            <div className="sp-use" data-testid="sp-use-listings">
              <h3>Win More Instructions</h3>
              <p>Vendors choose agents they trust. A polished avatar presentation at valuation stage sets you apart from every competitor.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="sp-section sp-section-white" data-testid="sp-session">
        <div className="sp-container">
          <h2 className="sp-h2 sp-h2-pink">The onboarding process</h2>
          <p className="sp-section-intro">
            Agents spend the day with our team in our dedicated tech studio. Professional
            capture, preparation, and guidance combine to ensure natural, confident results.
          </p>
          <div className="sp-grid">
            <div className="sp-card" data-testid="sp-card-studio">
              <Monitor size={20} className="sp-card-icon sp-icon-pink" />
              <h3>High-End Studio Capture</h3>
              <p>Controlled lighting and audio in our dedicated tech studio for professional-grade results.</p>
            </div>
            <div className="sp-card" data-testid="sp-card-autocue">
              <Video size={20} className="sp-card-icon sp-icon-pink" />
              <h3>Auto-Cue Assisted Delivery</h3>
              <p>Guided delivery using prepared auto-cue scripts for accuracy and consistency every time.</p>
            </div>
            <div className="sp-card" data-testid="sp-card-workshop">
              <Users size={20} className="sp-card-icon sp-icon-pink" />
              <h3>Workshop-Style Introduction</h3>
              <p>Guidance on posture, movement, and on-camera presence. Real confidence, not rehearsed lines.</p>
            </div>
            <div className="sp-card" data-testid="sp-card-ai">
              <Sparkles size={20} className="sp-card-icon sp-icon-pink" />
              <h3>AI Presenter Creation</h3>
              <p>Advanced multi-layer Avatar render created and calibrated for each agent individually.</p>
            </div>
            <div className="sp-card" data-testid="sp-card-tone">
              <Palette size={20} className="sp-card-icon sp-icon-pink" />
              <h3>Script Tone Alignment</h3>
              <p>Script tone aligned to your brand and sales approach, tested with real property descriptions.</p>
            </div>
            <div className="sp-card" data-testid="sp-card-reuse">
              <Layers size={20} className="sp-card-icon sp-icon-pink" />
              <h3>Setup for Repeat Use</h3>
              <p>Once onboarded, your agents can be reused across multiple properties. Save time while keeping content personal and consistent.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="sp-section sp-section-pink" data-testid="sp-pricing">
        <div className="sp-container sp-pricing-block">
          <h2 className="sp-h2 sp-h2-white">PresenTour Onboarding</h2>
          <div className="sp-price-row">
            <span className="sp-price">Avatar Day</span>
            <span className="sp-price-unit">£300 per agent</span>
          </div>
          <p className="sp-price-bulk">£250 per agent for 10+</p>
          <p className="sp-price-note">
            Once onboarded, your agents can be reused across multiple properties. Save time
            while keeping content personal and consistent.
          </p>
          <button className="sp-cta sp-cta-white" onClick={onDemo} data-testid="sp-pricing-cta">
            Book a Demo <ArrowRight size={16} />
          </button>
        </div>
      </section>

      <footer className="lp-footer" data-testid="sp-footer">
        <div className="lp-footer-inner">
          <div className="lp-footer-brand">
            <span className="lp-logo lp-logo-footer">
              <span className="lp-logo-niche">niche</span><span className="lp-logo-social">social</span>
            </span>
            <p className="lp-footer-powered">Powered by NicheCom property marketing assets.</p>
          </div>
          <nav className="lp-footer-links">
            <button onClick={onBack}>Back to NicheSocial</button>
          </nav>
        </div>
      </footer>
    </div>
  );
}
